// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import FileThumbnail from './file_thumbnail';

export default FileThumbnail;
